const getRolesList = state => state?.rolesListData?.rolesList
const getSingleRoleDetails = state => state?.rolesListData?.singleRoleDetails
const getCities = state => state?.rolesListData?.cities
const getRoleCities = state => state?.rolesListData?.roleCities
const getEligibleDetails = state => state?.rolesListData?.eligibleDetails
const getRoleFloatDetailsData = state => state?.rolesListData?.roleFloatDetails

const selector ={
    getRolesList,
    getSingleRoleDetails,
    getCities,
    getRoleCities,
    getEligibleDetails,
    getRoleFloatDetailsData
}

export default selector;